import { render, staticRenderFns } from "./helper-3.vue?vue&type=template&id=4907657e&scoped=true"
import script from "./helper-3.vue?vue&type=script&lang=js"
export * from "./helper-3.vue?vue&type=script&lang=js"
import style0 from "./helper-3.vue?vue&type=style&index=0&id=4907657e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907657e",
  null
  
)

export default component.exports